import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import DomainIcon from "@mui/icons-material/Domain";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import ScaleIcon from "@mui/icons-material/Scale";
import { Card, CardMedia, Grid, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  default as CustomSelect,
  default as Select,
} from "../../../components/Select/Select";
import {
  clinicReassignAppointmentById,
  clinicRescheduleAppointment,
  getAppointmentHistoriesByPetId,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getClinicFacilities,
  getClinicHolidays,
  getClinicInpatients,
  getClinicStocksWoLoader,
  getServices,
  getUserDetailsById,
} from "../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../redux/reducers/doctorSlice";
import { hideLoader, showLoader } from "../../../redux/reducers/loaderSlice";
import {
  createDiagnosticsWoLoader,
  createProcedureWoLoader,
  getPetDetailsById,
  petAppointment,
} from "../../../redux/reducers/petSlice";
import { getClinicVetsWithFilter } from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import {
  eyeBtn,
  w15h15BlueIcon,
  w25h25BlueIcon,
} from "../../../util/CommonIconStyle";
import {
  appointmentLaterList,
  appointmentList,
  doneAtList,
  oldIssueList,
  serviceTypes,
  serviceTypeWOSurgery,
  typeAppointemnt,
  typeList,
  typeListNew,
  visitTypes,
} from "../../../util/dropList";
import {
  adjustTime,
  getAllDatesFromArray,
  getAllSelectedSlots,
  getAvailableBayAtTime,
  getOnlyAvailableSlots,
  getProcedureDetails,
  getRequiredSlotList,
  getRightSaluation,
  getUpcoming60Dates,
} from "../../../util/function";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const getTomorrowDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

const getInitValues = () => ({
  bookingType: "Walk-in",
  consultationMode: "Physical",
  serviceType: { name: "Consultation", value: "Consultation" },
  visitType: { name: "New", value: "New" },
  reason: [],
  vetName: null,
  appointmentOption: "Immediate",
  date: new Date(),
  referenceCase: null,
  serviceName: [],
  remarks: "",
  facility: null,
  assignedUsers: [],
});
const initErrors = {};
const initTimeObj = { times: [], ids: [] };
const disableStatuses = ["consultation", "recovery", "finalize", "completed"];

const BookAnAppointment = ({
  modalVisible,
  setBookModVisible,
  selectedPet,
  prevAppointmentId = null,
  isEditAppointment = false,
  appointment = null,
  onBookModalCompleted = () => {},
  isReassign = false,
  rescheduleOrReassignModVsble = false,
}) => {
  const dispatch = useDispatch();
  const [modOpen, setModOpen] = useState(false);
  const [petValues, setPetValues] = useState(getInitValues);
  const [petErrors, setPetErrors] = useState(initErrors);
  const [selectTime, setSelectTime] = useState(null);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [timeObject, setTimeObject] = useState(initTimeObj);
  const [previewModVsble, setPreviewModVsble] = useState(false);
  const prevValuesRef = useRef({
    vetName: null,
    date: null,
    appointmentOption: null,
    consultationMode: null,
  });
  const prevAppointmentInitializedRef = useRef(false);
  const editAppointmentInitializedRef = useRef(false);
  const lastEditAppointmentIdRef = useRef(null);
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets)
  const clinicVets = useSelector((state) => state?.vet?.vetList?.vets);
  const {
    userDetails,
    vetAvailability,
    vetBookedApnts,
    petApntHistories,
    services,
    facilities,
    clinicStocks,
    inpatients,
  } = useSelector((state) => state?.clinic);
  // const clinicDet = useSelector((state) => state?.clinic?.details);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const clinicHolidays = useSelector((state) => state?.clinic?.holidays);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = user ? JSON.parse(user) : null;
  const isUnEditable =
    isEditAppointment && appointment
      ? disableStatuses?.includes(appointment?.appointmentStatus?.toLowerCase())
      : false;
  const isConsultationOrLater =
    isEditAppointment &&
    appointment &&
    ["consultation", "recovery", "finalize"].includes(
      appointment?.appointmentStatus?.toLowerCase(),
    );
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { dataSharing, clinic: clinicDet } = useMemo(() => {
    if (!mandateDataRaw) {
      return { dataSharing: {}, clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        dataSharing: reqData?.dataSharing ?? {},
        clinic: reqData?.clinic ?? {},
      };
    } catch {
      return { dataSharing: {}, clinic: {} };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    dispatch(getClinicHolidays());
    dispatch(getServices());
    dispatch(getClinicStocksWoLoader());
    dispatch(
      getClinicVetsWithFilter({
        type: ["all"],
        // type: ["doctor"],
        vetData: dataSharing?.vetData,
      }),
    );
    // dispatch(getClinicVets("?type=all"));
    dispatch(getClinicFacilities());
    dispatch(getClinicInpatients("?type=all"));
    if (selectedPet?.petId) {
      dispatch(getAppointmentHistoriesByPetId(selectedPet?.petId));
      dispatch(getPetDetailsById(selectedPet?.petId));
    }
  }, [selectedPet?.petId]);

  useEffect(() => {
    setModOpen(modalVisible);
    if (modalVisible && !isEditAppointment) {
      setPetValues((prev) => ({
        ...prev,
        date: new Date(),
      }));
    }
  }, [modalVisible, isEditAppointment]);

  const getServiceList = (itm) => {
    const reqCat =
      itm === "Grooming"
        ? "Hygiene & Grooming"
        : itm === "Lab Tests"
          ? "Lab"
          : itm === "Vaccination"
            ? "Preventive Care"
            : "Radiology";
    const reqList = [];
    let filList = services?.data?.filter(
      (sl) =>
        sl?.active === "Y" &&
        sl?.category?.toLowerCase() === reqCat?.toLowerCase(),
    );
    if (itm === "Grooming") {
      if (facilities?.filter((fl) => fl?.type === "BathBays").length === 0) {
        filList = filList?.filter(
          (sl) =>
            sl?.subCategory !== "Bathing" &&
            sl?.subCategory !== "Spa/Pampering Services",
        );
      }
    }
    if (itm === "Vaccination") {
      filList = filList?.filter(
        (sl) => sl?.subCategory?.toLowerCase() === "vaccination",
      );
    }
    filList?.forEach((li) => {
      if (li?.serviceVariants?.length > 0) {
        li?.serviceVariants?.forEach((vrnt) => {
          const reqObj = {
            serviceId: li?.serviceId,
            serviceName: li?.serviceName,
            variantName: vrnt?.variantName ?? "",
            estimatedDuration: vrnt?.estimatedDuration ?? "",
            servicePrice: vrnt?.servicePrice ?? 0,
            variantId: vrnt?.variantId ?? null,
            value: vrnt?.variantName ?? "",
            name: vrnt?.variantName ?? "",
            category: li?.category,
            subCategory: li?.subCategory,
          };
          reqList.push(reqObj);
        });
      } else {
        const reqObj = {
          serviceId: li?.serviceId,
          serviceName: li?.serviceName,
          servicePrice: li?.servicePrice ?? 0,
          estimatedDuration: li?.estimatedDuration ?? "",
          name: li?.serviceName,
          value: li?.serviceName,
        };
        reqList.push(reqObj);
      }
    });
    return reqList ?? [];
  };

  useEffect(() => {
    if (
      !isEditAppointment &&
      prevAppointmentId &&
      petApntHistories?.length > 0 &&
      !prevAppointmentInitializedRef.current
    ) {
      const reqHistory = petApntHistories?.find(
        (hist) => hist?.appointmentId === prevAppointmentId,
      );
      if (reqHistory) {
        setPetValues((prev) => ({
          ...prev,
          reason: ["FollowUp"],
          referenceCase: {
            name: `Case Id: ${reqHistory?.caseId ?? ""} ${
              reqHistory?.serviceType
            }${
              reqHistory?.serviceType === "Consultation"
                ? ` | ${
                    Array.isArray(reqHistory?.reason)
                      ? reqHistory?.reason?.join(", ")
                      : reqHistory?.reason
                  }`
                : ""
            }`,
            value: reqHistory?.appointmentId ?? prevAppointmentId,
          },
        }));
        prevAppointmentInitializedRef.current = true;
      }
    }
    // Reset ref when conditions change
    if (isEditAppointment || !prevAppointmentId) {
      prevAppointmentInitializedRef.current = false;
    }
  }, [prevAppointmentId, petApntHistories, isEditAppointment]);

  useEffect(() => {
    const currentAppointmentId = appointment?.appointmentId;

    // Reset ref if switching to a different appointment or exiting edit mode
    if (
      !isEditAppointment ||
      !appointment ||
      (lastEditAppointmentIdRef.current !== null &&
        lastEditAppointmentIdRef.current !== currentAppointmentId)
    ) {
      editAppointmentInitializedRef.current = false;
      lastEditAppointmentIdRef.current = null;
    }

    if (
      isEditAppointment &&
      appointment &&
      !editAppointmentInitializedRef.current &&
      services?.data &&
      currentAppointmentId
    ) {
      const reqRefNo = (petApntHistories ?? [])?.find(
        (hl) => hl?.appointmentId === appointment?.prevAppointmentId,
      );
      const reqVet = clinicVets?.find(
        (vl) => vl?.doctorId === appointment?.doctorId,
      ) ?? {
        doctorId: appointment?.doctorId,
        name: appointment?.doctorName,
        id: appointment?.doctorName,
      };
      const assignedUsers =
        appointment?.assignedUsers?.length > 0
          ? appointment?.assignedUsers?.map((li) => {
              const matUser = clinicVets?.find((vl) => vl?.doctorId === li);
              return {
                id: li,
                name: `${getRightSaluation(clinicVets, li)}${matUser?.name}`,
                value: li,
              };
            })
          : [];
      const reqServType = serviceTypes?.find(
        (st) =>
          st?.value?.toLowerCase() === appointment?.serviceType?.toLowerCase(),
      );
      const servList = getServiceList(appointment?.serviceType);
      const reqServList =
        appointment?.serviceNames?.length > 0
          ? appointment?.serviceNames
              ?.map((li) => {
                const matchedServ = servList?.find(
                  (sl) => sl?.serviceId === li?.serviceId,
                );
                return matchedServ;
              })
              ?.filter(Boolean)
          : [];
      const reqObj = {
        assignedUsers,
        vetName: {
          name: `${getRightSaluation(clinicVets, reqVet?.doctorId)}${reqVet?.name}`,
          value: reqVet?.doctorId,
          id: reqVet?.doctorId,
          facility: reqVet?.facility,
        },
        serviceType: reqServType,
        consultationMode: appointment?.appointmentType,
        bookingType: appointment?.bookingType,
        remarks: appointment?.remarks,
        facility: appointment?.facilityId
          ? {
              name: appointment?.facility,
              value: appointment?.facilityId,
              id: appointment?.facilityId,
            }
          : null,
        appointmentOption: appointment?.immediate ? "Immediate" : "Later",
        reason: appointment?.reason ?? [],
        referenceCase: reqRefNo
          ? {
              name: `Case Id: ${reqRefNo?.caseId ?? ""} ${reqRefNo?.serviceType}${
                reqRefNo?.serviceType === "Consultation"
                  ? ` | ${
                      Array.isArray(reqRefNo?.reason)
                        ? reqRefNo?.reason?.join(", ")
                        : reqRefNo?.reason
                    }`
                  : ""
              }`,
              value: reqRefNo?.appointmentId ?? appointment?.prevAppointmentId,
            }
          : null,
        date: new Date(),
        serviceName: reqServList,
        visitType: visitTypes?.find(
          (vt) =>
            vt?.value?.toLowerCase() === appointment?.visitType?.toLowerCase(),
        ),
      };
      setPetValues(reqObj);
      editAppointmentInitializedRef.current = true;
      lastEditAppointmentIdRef.current = currentAppointmentId;
    }
  }, [
    isEditAppointment,
    appointment,
    appointment?.appointmentId,
    appointment?.serviceType,
    clinicVets,
    petApntHistories,
    services?.data,
  ]);

  useEffect(() => {
    if (
      !petValues?.vetName?.value ||
      !petValues?.date ||
      !petValues?.appointmentOption ||
      !petValues?.consultationMode ||
      !profile?.id
    ) {
      return;
    }

    let formattedDate = null;
    try {
      if (petValues?.date) {
        const dateObj = new Date(petValues?.date);
        if (!isNaN(dateObj.getTime())) {
          formattedDate = moment(dateObj).format("YYYY-MM-DD");
        }
      }
    } catch (error) {
      console.error("Error formatting date:", error);
    }

    const currentValues = {
      vetName: petValues?.vetName?.value,
      date: formattedDate,
      appointmentOption: petValues?.appointmentOption,
      consultationMode: petValues?.consultationMode,
    };

    const prevValues = prevValuesRef.current;

    // Check if any values have actually changed
    const hasChanged =
      prevValues.vetName !== currentValues.vetName ||
      prevValues.date !== currentValues.date ||
      prevValues.appointmentOption !== currentValues.appointmentOption ||
      prevValues.consultationMode !== currentValues.consultationMode;

    if (!hasChanged) {
      return;
    }

    if (petValues?.appointmentOption === "Later" && formattedDate) {
      dispatch(getVetHolidaysById(petValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: petValues?.vetName?.value,
          type:
            (role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id) ===
            petValues?.vetName?.value
              ? "Physical"
              : petValues?.consultationMode,
        }),
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: petValues?.vetName?.value,
          date: formattedDate,
          clinicId: profile?.id,
        }),
      );
    }

    // Update ref with current values
    prevValuesRef.current = currentValues;
  }, [
    dispatch,
    petValues?.vetName?.value,
    petValues?.date,
    petValues?.appointmentOption,
    petValues?.consultationMode,
    role,
    profile?.id,
    clinicDet?.id,
  ]);

  const isPetInInpatientToday = () => {
    return inpatients?.data?.some(
      (li) =>
        li?.petId === selectedPet?.petId &&
        moment(new Date(li?.appointmentdateTime)).format("YYYY-MM-DD") ===
          moment(new Date()).format("YYYY-MM-DD"),
    );
  };

  useEffect(() => {
    if (inpatients?.data?.length > 0 && isPetInInpatientToday()) {
      setPetValues({
        ...petValues,
        date: getTomorrowDate(),
        appointmentOption: "Later",
      });
    }
  }, [inpatients, isPetInInpatientToday()]);

  useEffect(() => {
    getHolidayDateList();
  }, [holidays, clinicHolidays, vetAvailability]);

  const getHolidayDateList = () => {
    if (
      (holidays?.length === 0 || !holidays) &&
      (clinicHolidays?.length === 0 || !clinicHolidays) &&
      vetAvailability?.every((li) => li?.status)
    ) {
      return setHolidayDates([]);
    }
    const vetDates = getAllDatesFromArray(holidays) ?? [];
    const cliHolidays =
      clinicHolidays?.map((hl) => {
        return hl?.date;
      }) ?? [];
    const unAvilableDates =
      vetAvailability?.length > 0 ? getUpcoming60Dates(vetAvailability) : [];
    const mergedArray = vetDates?.concat(cliHolidays, unAvilableDates);
    setHolidayDates(uniq(mergedArray));
  };

  const handleReset = () => {
    setPetValues(getInitValues());
    setPetErrors(initErrors);
    setSelectTime(null);
    setSelectTimeIdError(false);
  };

  const onCloseMod = () => {
    setBookModVisible(false);
    setModOpen(false);
    setSelectTime(null);
    handleReset();
  };

  const onChange = (value, name) => {
    const reqObj = { ...petValues, [name]: value };
    const errObj = { ...petErrors };
    if (name === "bookingType" && value === "Phone") {
      reqObj.appointmentOption = "Later";
    }
    if (name === "serviceType" && value === "Surgery") {
      reqObj.appointmentOption = "Later";
    }
    if (name === "serviceType") {
      reqObj.serviceName = [];
      reqObj.facility = null;
      // if (value?.value === "Surgery" || value?.value === "Grooming") {
      //   dispatch(getClinicFacilities());
      // }
    }
    if (name === "serviceName") {
      errObj.serviceName = value?.length === 0 ? "This field is required" : "";
    }
    if (name === "vetName") {
      errObj.vetName = !value ? "This field is required" : "";
      const facMat = facilities?.find(
        (fl) => fl?.facilityId === value?.facility,
      );
      reqObj.facility =
        value?.facility && facMat
          ? {
              name: facMat?.name,
              value: facMat?.facilityId ?? value?.facility,
              id: facMat?.facilityId ?? value?.facility,
            }
          : null;
    }
    if (name === "consultationMode" && value === "Home") {
      dispatch(getUserDetailsById(selectedPet?.userId));
    }
    setPetErrors(errObj);
    setPetValues(reqObj);
  };

  const handleSelectectedTimeIds = (time) => {
    const reqTimeIds = [...timeObject?.times, time];
    let ids = [];
    const reqList = {
      times: reqTimeIds?.length > 2 ? [time] : reqTimeIds,
    };
    if (reqList?.times?.length === 2) {
      ids = getAllSelectedSlots(
        getRequiredSlotList({
          availability: vetAvailability,
          date: petValues?.date,
          bookedApnts: vetBookedApnts,
        }),
        reqTimeIds,
      );
      reqList.ids = ids;
    } else {
      ids.push(time);
      reqList.ids = ids;
    }
    setTimeObject(reqList);
    setSelectTimeIdError(reqTimeIds?.length === 2 ? false : true);
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const getHistoryList = () => {
    if (!petApntHistories || petApntHistories?.length === 0) return [];
    return petApntHistories?.map((hl) => ({
      name: `Case Id: ${hl?.caseId ?? ""} ${hl?.serviceType}${
        hl?.serviceType === "Consultation"
          ? ` | ${
              Array.isArray(hl?.reason) ? hl?.reason?.join(", ") : hl?.reason
            }`
          : ""
      }`,
      value: hl?.appointmentId,
    }));
  };

  const getAppointmentHistoryStats = () => {
    if (!petApntHistories || petApntHistories?.length === 0) {
      return {
        lastAppointment: null,
        totalAppointments: 0,
        noShows: 0,
      };
    }

    // Sort by date to get the most recent appointment
    const sortedHistories = [...petApntHistories].sort((a, b) => {
      const dateA = new Date(
        a?.appointmentDate ||
          a?.date ||
          a?.appointmentDateTime ||
          a?.visitDate ||
          0,
      );
      const dateB = new Date(
        b?.appointmentDate ||
          b?.date ||
          b?.appointmentDateTime ||
          b?.visitDate ||
          0,
      );
      return dateB - dateA;
    });

    const lastAppointment = sortedHistories[0];
    const totalAppointments = petApntHistories?.length || 0;

    // Count no shows - checking for "noshow", "no-show", "no show" or "cancelled" status
    const noShows =
      petApntHistories?.filter((apt) => {
        const status =
          apt?.appointmentStatus?.toLowerCase() ||
          apt?.status?.toLowerCase() ||
          "";
        return (
          status.includes("noshow") ||
          status.includes("no-show") ||
          status.includes("no show") ||
          status === "cancelled"
        );
      }).length || 0;

    return {
      lastAppointment,
      totalAppointments,
      noShows,
    };
  };

  const getVetList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => {
          if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
            return vl;
          }
        })
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getAllClinicUserListWoSelectedVet = (vetId) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter(
          (vl) =>
            vl?.status === "Y" &&
            vl?.doctorId !== vetId &&
            vl?.userType?.some(
              (ut) => ut?.name === "ROLE_DOCTOR" || ut?.name === "ROLE_GROOMER",
            ),
        )
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        })
        ?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? "")) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            facility: vet?.facility,
          };
        }) ?? [];
    reqVetList.unshift({
      name: `${
        role === "ROLE_CLINIC" ? profile?.name : clinicDet?.name
      } (Clinic)`,
      value: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      id: role === "ROLE_CLINIC" ? profile?.id : clinicDet?.id,
      facility: null,
    });
    return reqVetList;
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      petValues?.consultationMode === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Vaccination" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => (fl?.type ?? "")?.toLowerCase() !== "devices")
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];

    return reqVetList;
  };

  const getFacilityUnAvailListById = (id) => {
    const reqFacility = facilities?.find((fl) => fl?.facilityId === id) ?? {};
    if (!reqFacility) return [];
    return (
      reqFacility?.clinicFacilitiesUnavaility
        ?.filter(
          (ua) =>
            ua?.appointmentDate ===
            moment(petValues?.date).format("YYYY-MM-DD"),
        )
        ?.map((li) => ({
          ...li,
          startTime: li?.appointmentStartTime,
          endTime: li?.appointmentEndTime,
        })) ?? []
    );
  };

  const getBaseSlotList = () =>
    getRequiredSlotList({
      availability: vetAvailability,
      date: petValues?.date,
      bookedApnts: vetBookedApnts,
      holidays,
    });

  const getBookableSlotList = () => {
    const baseSlots = getBaseSlotList();
    if (!petValues?.facility?.value) return baseSlots;
    return getOnlyAvailableSlots(
      getFacilityUnAvailListById(petValues?.facility?.value),
      baseSlots,
    );
  };

  const handleAddDiag = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const form = new FormData();
      form.append("appId", apntId);
      form.append("type", li?.category);
      form.append("testName", li?.serviceName);
      form.append("doneAt", doneAtList?.[0]?.value);
      form.append("sampleCollected", false);
      form.append("priority", "Routine");
      form.append("price", li?.servicePrice);
      form.append("tax", 0);
      form.append(
        "dueDate",
        moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date),
        ).format("YYYY-MM-DD"),
      );
      form.append("remark", "");
      form.append("serviceId", li?.serviceId);
      form.append("variantId", li?.variantId);
      form.append("variantName", li?.variantName);
      form.append("status", "In Progress");
      dispatch(
        createDiagnosticsWoLoader({
          appointmentId: apntId,
          form,
          formData: true,
        }),
      );
    });
  };

  const handleAddProcedure = (petVal, apntId) => {
    const list = petVal?.serviceName;
    list?.forEach((li) => {
      const procedureDetails = getProcedureDetails(
        li?.serviceId,
        li?.variantId,
        li?.serviceName,
        services?.data ?? [],
        clinicStocks?.data ?? [],
        clinicDet?.pharmacyTaxId,
      )?.procedureDetails;
      const data = {
        procedureName: li?.serviceName,
        serviceId: li?.serviceId,
        category: li?.category,
        subCategory: li?.subCategory,
        remarks: li?.remarks ?? "",
        doneAt: moment(
          petVal?.appointmentOption === "Immediate"
            ? new Date()
            : new Date(petVal?.date),
        ).format("YYYY-MM-DD"),
        status: "Pending",
        petId: selectedPet?.petId,
        appointmentId: apntId,
        serviceCharge: li?.servicePrice,
        serviceType: li?.variantName,
        procedureDetails,
      };
      dispatch(createProcedureWoLoader({ data }));
    });
  };

  const onPreview = () => {
    const reqErrs = {};
    if (!petValues?.vetName?.value) {
      reqErrs.vetName = "This field is required";
    }
    // if (
    //   !isConsultationOrLater &&
    //   (petValues?.serviceType?.value === "Grooming" ||
    //     petValues?.serviceType?.value === "Lab Tests" ||
    //     petValues?.serviceType?.value === "Radiology Tests")
    //   // ||
    //   // petValues?.serviceType?.value === "Others"
    // ) {
    //   if (petValues?.serviceName?.length === 0) {
    //     reqErrs.serviceName = "This field is required";
    //   }
    // }

    if (
      !isConsultationOrLater &&
      (Object.keys(reqErrs)?.length > 0 ||
        (petValues?.serviceType?.value !== "Surgery" &&
          petValues?.appointmentOption !== "Immediate" &&
          !selectTime) ||
        (petValues?.serviceType?.value === "Surgery" &&
          timeObject?.ids?.length < 2))
    ) {
      if (
        (petValues?.serviceType?.value !== "Surgery" &&
          petValues?.appointmentOption !== "Immediate" &&
          !selectTime) ||
        (petValues?.serviceType?.value === "Surgery" &&
          timeObject?.ids?.length < 2)
      ) {
        setSelectTimeIdError(true);
      }
      setPetErrors(reqErrs);
      return;
    }
    setPreviewModVsble(true);
    setModOpen(false);
  };

  const handleSubmit = () => {
    dispatch(showLoader());
    const isImmediate = petValues?.appointmentOption === "Immediate";
    const startTime = isImmediate
      ? moment(new Date()).format("HH:mm")
      : selectTime;
    const data = {
      doctorId: petValues?.vetName?.value,
      facility: petValues?.facility?.name ?? null,
      facilityId: petValues?.facility?.value ?? null,
      remarks: petValues?.remarks,
      // bookingType: petValues?.bookingType,
      // consultationMode: petValues?.consultationMode,
      // serviceType: petValues?.serviceType?.value,
      // immediate: isImmediate,
      // appointmentDate: isImmediate
      //   ? moment(new Date()).format("YYYY-MM-DD")
      //   : moment(new Date(petValues?.date)).format("YYYY-MM-DD"),
      // visitType: petValues?.visitType?.value,
    };
    if (!isConsultationOrLater) {
      data.bookingType = petValues?.bookingType;
      data.consultationMode = petValues?.consultationMode;
      data.serviceType = petValues?.serviceType?.value;
      data.immediate = isImmediate;
      data.appointmentDate = isImmediate
        ? moment(new Date()).format("YYYY-MM-DD")
        : moment(new Date(petValues?.date)).format("YYYY-MM-DD");
      data.visitType = petValues?.visitType?.value;
    }
    if (petValues?.assignedUsers?.length > 0) {
      data.assignedUsers = petValues?.assignedUsers?.map((li) => li?.id);
    }
    if (petValues?.serviceType?.value === "Consultation") {
      data.reason = petValues?.reason;
      if (!isConsultationOrLater) {
        data.appointmentStartTime = startTime;
        data.appointmentEndTime = adjustTime(
          startTime,
          getRequiredSlotList({
            availability: vetAvailability,
            date: petValues?.date,
            isDuration: true,
          }),
        );
      }
    }

    if (petValues?.serviceType?.value === "Surgery" && !isConsultationOrLater) {
      data.appointmentStartTime = isImmediate
        ? startTime
        : timeObject?.ids?.[0]?.startTime;
      data.appointmentEndTime = isImmediate
        ? adjustTime(
            isImmediate
              ? startTime
              : timeObject?.ids?.[timeObject?.ids?.length - 1]?.startTime,
            getRequiredSlotList({
              availability: vetAvailability,
              date: petValues?.date,
              isDuration: true,
            }),
          )
        : timeObject?.ids?.[timeObject?.ids?.length - 1]?.startTime;
    }

    if (
      petValues?.serviceType?.value !== "Consultation" &&
      petValues?.serviceType?.value !== "Surgery" &&
      !isConsultationOrLater
    ) {
      data.serviceNames = petValues?.serviceName?.map((li) => ({
        serviceName: li?.serviceName,
        serviceId: li?.serviceId,
        variantId: li?.variantId,
      }));
      const reqTimeInMins =
        petValues?.serviceType?.value === "Others"
          ? 0
          : petValues?.serviceName?.reduce((acc, obj) => {
              return acc + (Number(obj?.estimatedDuration ?? 0) ?? 0);
            }, 0);
      data.appointmentStartTime = startTime;
      data.appointmentEndTime = adjustTime(
        startTime,
        reqTimeInMins > 0
          ? reqTimeInMins
          : getRequiredSlotList({
              availability: vetAvailability,
              date: petValues?.date,
              isDuration: true,
            }),
      );
      if (
        petValues?.serviceName?.some(
          (item) =>
            item?.subCategory?.includes("Bathing") ||
            item?.subCategory?.includes("Spa/Pampering Services"),
        )
      ) {
        if (facilities?.filter((fl) => fl?.type === "BathBays")?.length === 1) {
          data.facility =
            petValues?.facility?.name ??
            getFacilitiesByType("Grooming")?.[0]?.name ??
            null;
          data.facilityId =
            petValues?.facility?.value ??
            getFacilitiesByType("Grooming")?.[0]?.value ??
            null;
        } else {
          const reqFacility = getAvailableBayAtTime(
            facilities?.filter((fl) => fl?.type === "BathBays"),
            selectTime,
            moment(petValues?.date).format("YYYY-MM-DD"),
          );
          if (reqFacility) {
            data.facility =
              petValues?.facility?.name ?? reqFacility?.name ?? null;
            data.facilityId =
              petValues?.facility?.value ?? reqFacility?.facilityId ?? null;
          }
        }
      }
    }
    if (
      petValues?.visitType?.value === "Follow-up" &&
      petValues?.referenceCase?.value &&
      !isConsultationOrLater
    ) {
      data.prevAppointmentId = petValues?.referenceCase?.value;
    }
    if (isEditAppointment && appointment) {
      dispatch(
        isConsultationOrLater
          ? clinicReassignAppointmentById({
              appointmentId: appointment?.appointmentId,
              data,
            })
          : clinicRescheduleAppointment({
              appointmentId: appointment?.appointmentId,
              data,
            }),
      ).then((res) => {
        if (res?.payload) {
          onCloseMod();
          onBookModalCompleted("Api Success");
          setPreviewModVsble(false);
          setBookModVisible(false);
          dispatch(hideLoader());
        } else {
          dispatch(hideLoader());
        }
      });
    } else {
      dispatch(petAppointment({ data, petId: selectedPet?.petId })).then(
        (res) => {
          if (res?.payload) {
            if (
              (petValues?.serviceType?.value === "Radiology Tests" ||
                petValues?.serviceType?.value === "Lab Tests" ||
                petValues?.serviceType?.value === "Grooming") &&
              res?.payload?.data?.appointmentId
            ) {
              if (
                petValues?.serviceType?.value === "Radiology Tests" ||
                petValues?.serviceType?.value === "Lab Tests"
              ) {
                handleAddDiag(petValues, res?.payload?.data?.appointmentId);
              }
              if (petValues?.serviceType?.value === "Grooming") {
                handleAddProcedure(
                  petValues,
                  res?.payload?.data?.appointmentId,
                );
              }
            }
            onCloseMod();
            onBookModalCompleted("Api Success");
            setPreviewModVsble(false);
            setBookModVisible(false);
            dispatch(hideLoader());
          } else {
            dispatch(hideLoader());
          }
        },
      );
    }
  };

  const onClosePreviewMod = () => {
    setModOpen(true);
    setPreviewModVsble(false);
  };

  return (
    <>
      <CustomModal
        open={modOpen}
        onClose={onCloseMod}
        header={
          isEditAppointment
            ? rescheduleOrReassignModVsble
              ? "Reschedule/Reassign"
              : // ? isReassign
                //   ? "Reassign"
                //   : "Reschedule"
                "Edit Appointment"
            : "Book an Appointment"
        }
        modalWidth={80}
        modal
      >
        <Grid container spacing={2} className="ph20 scroll-80vh">
          <Grid item xs={12} sm={12} md={3.5} lg={3.5} xl={3.5}>
            <Card
              sx={cardSty}
              // className="CustomCard-back-appointment"
            >
              {/* <div className="maint"> */}
              <div className="flex-row">
                <Grid item xs={3}>
                  <div className="flex-center">
                    {selectedPet?.petImage ? (
                      <CardMedia
                        image={selectedPet?.petImage}
                        className="CustomCard-img3-bill"
                      />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {selectedPet?.petName?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <Typography className="mb10 txt-semi-bold fs14 card-black capitalize">
                            {selectedPet?.petName}
                          </Typography>
                          <Typography
                            className={`ml5 font-medium capitalize fs14 ${
                              selectedPet?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${selectedPet?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {selectedPet?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </Grid>
              </div>
              {/* </div> */}
            </Card>

            <div className="flex-row-ali-cen mt10">
              <DataUsageIcon sx={w25h25BlueIcon} />
              <Typography className="txt-semi-bold gray39 fs14 ml10">
                Age :{" "}
              </Typography>
              <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                {moment(new Date(selectedPet?.dob)).fromNow(true)} (
                {selectedPet?.dob})
              </Typography>
            </div>
            <div className="flex-row-ali-cen mt10">
              <ColorLensIcon sx={w25h25BlueIcon} />
              <Typography className="txt-semi-bold gray39 fs14 ml10">
                Color :{" "}
              </Typography>
              <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                {selectedPet?.color ?? ""}
              </Typography>
            </div>
            <div className="flex-row-ali-cen mt10">
              <ScaleIcon sx={w25h25BlueIcon} />
              <Typography className="txt-semi-bold gray39 fs14 ml10">
                Weight :{" "}
              </Typography>
              <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                {selectedPet?.weight?.length > 0
                  ? `${selectedPet?.weight} KG`
                  : ""}
              </Typography>
            </div>
            <div className="flex-row-ali-cen mt10">
              <AccountCircleOutlinedIcon sx={w25h25BlueIcon} />
              <Typography className="txt-semi-bold gray39 fs14 ml10">
                Parent Name :{" "}
              </Typography>
              <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                {selectedPet?.userName}
                {(selectedPet?.userMobile ?? selectedPet?.mobile)?.length > 0 &&
                  ` (${selectedPet?.userMobile ?? selectedPet?.mobile})`}
              </Typography>
            </div>

            <div className="flex-row-ali-cen mb5 mt15">
              <div className="flex-row-wrap flex-row">
                <img
                  src={require("../../../assets/images/png/allergyIcon.png")}
                  alt=""
                  className="img-wh20"
                />
                <Typography className="txt-semi-bold fs14 balck ml10">
                  Alerts:
                </Typography>
                {petDetails?.allergies?.length > 0 ? (
                  petDetails?.allergies?.map((al, i) => (
                    <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                      {`${al?.allergies}${
                        i + 1 === petDetails?.allergies?.length ? "" : ","
                      }`}
                    </Typography>
                  ))
                ) : (
                  <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                    None specified
                  </Typography>
                )}
              </div>
            </div>

            <Typography className="text-bold fs14 blue-color">
              Internal Tags
            </Typography>
            <div className="flex-row-wrap1">
              {petDetails?.petInternalTags?.map((tg) => (
                <div
                  className="flex-row-ali-cen pv5 ph10 cursor br5 mh5 mv5"
                  style={{ background: tg?.color }}
                  key={tg?.internalId}
                >
                  <Typography className="font-bold fs10 white-color">
                    {tg?.tags}
                  </Typography>
                </div>
              ))}
            </div>

            {/* Appointment History Section */}
            {(() => {
              const stats = getAppointmentHistoryStats();
              const lastVisitDate =
                petDetails?.lastVisitDate ||
                stats?.lastAppointment?.appointmentDate ||
                stats?.lastAppointment?.date ||
                stats?.lastAppointment?.appointmentDateTime ||
                stats?.lastAppointment?.visitDate;
              return (
                <div className="mt5">
                  <Typography className="text-bold blue-color fs14">
                    Appointment History
                  </Typography>
                  {lastVisitDate && (
                    <div>
                      <div className="flex-row-ali-cen">
                        <Typography className="txt-semi-bold gray39 fs14">
                          Last Appointment :{" "}
                        </Typography>
                        <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                          {moment(lastVisitDate).format("DD MMM YYYY, HH:mm")}
                        </Typography>
                      </div>
                      {(petDetails?.vetName ||
                        stats?.lastAppointment?.doctorName ||
                        stats?.lastAppointment?.vetName) && (
                        <div className="flex-row-ali-cen">
                          <Typography className="txt-semi-bold gray39 fs14">
                            Vet :{" "}
                          </Typography>
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {petDetails?.vetName ||
                              stats?.lastAppointment?.doctorName ||
                              stats?.lastAppointment?.vetName}
                          </Typography>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="flex-row-ali-cen">
                    <Typography className="txt-semi-bold gray39 fs14">
                      Total Appointments :{" "}
                    </Typography>
                    <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                      {petDetails?.totalAppointments ||
                        stats?.totalAppointments ||
                        0}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen">
                    <Typography className="txt-semi-bold gray39 fs14">
                      No Shows :{" "}
                    </Typography>
                    <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                      {petDetails?.noShows !== null &&
                      petDetails?.noShows !== undefined
                        ? petDetails?.noShows
                        : stats?.noShows || 0}
                    </Typography>
                  </div>
                </div>
              );
            })()}
          </Grid>
          <Grid item xs={12} sm={12} md={8.5} lg={8.5} xl={8.5}>
            <div className="flex-row">
              <div className="w2Per">
                <div className="gry-ver-split" />
              </div>
              <div className="w98Per">
                <Grid container spacing={2} className="mt5">
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <CustomSelect
                      list={typeAppointemnt}
                      value={petValues?.bookingType}
                      handleChange={(e) =>
                        onChange(e?.target?.value, "bookingType")
                      }
                      name="bookingType"
                      label="Booking Type * "
                      select
                      helperText={petErrors?.bookingType}
                      error={!!petErrors?.bookingType}
                      disabled={isUnEditable}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                    <CustomSelect
                      list={
                        petValues.bookingType === "Walk-in"
                          ? typeListNew
                          : typeList
                      }
                      value={
                        petValues?.bookingType === "Walk-in"
                          ? "Physical"
                          : petValues?.consultationMode
                      }
                      handleChange={(e) =>
                        onChange(e?.target?.value, "consultationMode")
                      }
                      name="consultationMode"
                      label="Consultation Mode * "
                      select
                      helperText={petErrors?.consultationMode}
                      error={!!petErrors?.consultationMode}
                      disabled={isUnEditable}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <CustomSelect
                      list={
                        petValues?.consultationMode === "Physical"
                          ? serviceTypes
                          : serviceTypeWOSurgery
                      }
                      value={petValues?.serviceType}
                      handleChange={(e, value) =>
                        onChange(value, "serviceType")
                      }
                      search
                      helperText={petErrors?.serviceType}
                      error={!!petErrors?.serviceType}
                      label="Service Type *"
                      name="serviceType"
                      disabled={isUnEditable}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <CustomSelect
                      list={visitTypes}
                      value={petValues?.visitType}
                      handleChange={(e, value) => onChange(value, "visitType")}
                      search
                      helperText={petErrors?.visitType}
                      error={!!petErrors?.visitType}
                      label="Visit Type *"
                      name="visitType"
                      disabled={isUnEditable}
                    />
                  </Grid>
                  {petValues?.serviceType?.value === "Consultation" ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomSelect
                        list={oldIssueList}
                        value={petValues?.reason}
                        handleChange={(e) => {
                          onChange(e, "reason");
                        }}
                        reason
                        label="Reason"
                        name="reason"
                        helperText={petErrors?.reason}
                        error={!!petErrors?.reason}
                      />
                    </Grid>
                  ) : null}
                  {petValues?.visitType?.value === "Follow-up" ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomSelect
                        list={getHistoryList()}
                        value={petValues?.referenceCase}
                        handleChange={(e, value) =>
                          onChange(value, "referenceCase")
                        }
                        search
                        label="Reference Case"
                        name="referenceCase"
                        helperText={petErrors?.referenceCase}
                        error={!!petErrors?.referenceCase}
                        disabled={isUnEditable}
                      />
                    </Grid>
                  ) : null}
                  {petValues?.serviceType?.value === "Grooming" ||
                  petValues?.serviceType?.value === "Lab Tests" ||
                  petValues?.serviceType?.value === "Radiology Tests" ||
                  // petValues?.serviceType?.value === "Others" ||
                  petValues?.serviceType?.value === "Vaccination" ? (
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomSelect
                        list={getServiceList(petValues?.serviceType?.value)}
                        value={petValues?.serviceName}
                        handleChange={(e) => onChange(e, "serviceName")}
                        service
                        label="Service Name"
                        // label="Service Name *"
                        name="serviceName"
                        helperText={petErrors?.serviceName}
                        error={!!petErrors?.serviceName}
                        disabled={isUnEditable}
                      />
                    </Grid>
                  ) : null}
                  <Grid
                    item
                    xs={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
                    sm={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
                    md={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
                    lg={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
                    xl={petValues?.serviceType?.value === "Surgery" ? 6 : 12}
                  >
                    <Select
                      list={
                        petValues?.serviceType?.value === "Grooming" ||
                        petValues?.serviceType?.value === "Lab Tests" ||
                        petValues?.serviceType?.value === "Radiology Tests"
                          ? getOthersByType(petValues?.serviceType?.value)
                          : petValues?.serviceType?.value === "Others"
                            ? getAllClinicUserList()
                            : getVetList()
                      }
                      value={petValues?.vetName}
                      handleChange={(e, value) => onChange(value, "vetName")}
                      name="vetName"
                      search
                      helperText={petErrors?.vetName}
                      error={!!petErrors?.vetName}
                      label={`${
                        petValues?.serviceType?.value === "Grooming"
                          ? "Groomer"
                          : petValues?.serviceType?.value === "Lab Tests" ||
                              petValues?.serviceType?.value ===
                                "Radiology Tests"
                            ? "Technician"
                            : // : petValues?.serviceType?.value === "Others"
                              // ? "Others"
                              "Vet"
                      } Name *`}
                      labelTop
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Select
                      list={getAllClinicUserListWoSelectedVet(
                        petValues?.vetName?.value,
                      )}
                      value={petValues?.assignedUsers ?? []}
                      name="assignedUsers"
                      handleChange={(e) => {
                        onChange(e?.target?.value, "assignedUsers");
                      }}
                      label="Assigned Users"
                      multiSelectSearchCheck
                    />
                  </Grid>
                  {petValues?.consultationMode === "Physical" ||
                  petValues?.consultationMode === "Home" ? (
                    //   &&
                    // (petValues?.serviceType?.value === "Consultation" ||
                    //   petValues?.serviceType?.value === "Surgery")
                    <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Select
                        list={getFacilitiesByType(
                          petValues?.serviceType?.value,
                        )}
                        value={petValues?.facility}
                        handleChange={(e, value) => onChange(value, "facility")}
                        name="facility"
                        search
                        helperText={petErrors?.facility}
                        error={!!petErrors?.facility}
                        label={
                          petValues?.consultationMode === "Home"
                            ? "Kit Name"
                            : "Facility"
                        }
                        labelTop
                      />
                    </Grid>
                  ) : null}
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="flex-row-ali-cen mtMin5">
                      <div className="gray7 fs14 mtMin5 txt-semi-bold">
                        Appointment <span className="red-color">*</span> :
                      </div>
                      <div className="ml5">
                        <CustomCheckbox
                          radio
                          value={petValues?.appointmentOption}
                          onChange={(e) =>
                            onChange(e?.target?.value, "appointmentOption")
                          }
                          radios={
                            petValues.bookingType === "Phone" ||
                            petValues?.serviceType?.value === "Surgery" ||
                            isPetInInpatientToday()
                              ? appointmentLaterList
                              : appointmentList
                          }
                          defaultValue={petValues?.appointmentOption}
                          disabled={isUnEditable}
                        />
                      </div>
                    </div>
                    {isPetInInpatientToday() && (
                      <Typography className="red2 fs12 txt-regular">
                        Patient is currently under inpatient
                      </Typography>
                    )}
                    {petErrors?.appointmentOption && (
                      <Typography color="error" className="ml5 mt5 fs14">
                        Appointment is Required
                      </Typography>
                    )}
                  </Grid>
                  {/* {petValues?.serviceType?.value === "Surgery" &&
        petValues?.appointmentOption === "Immediate" ? (
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <CustomTextField
              name="kennelNumber"
              fullWidth
              handleChange={(e) => onChange(e?.target?.value, "kennelNumber")}
              value={petValues?.kennelNumber}
              helperText={petErrors?.kennelNumber}
              error={!!petErrors?.kennelNumber}
              label="Kennel Number "
            />
          </Grid>
        ) : null} */}
                  {petValues?.appointmentOption === "Later" && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <div className="mb20">
                        <CustomTextField
                          name="date"
                          value={petValues?.date}
                          labelTop
                          fullWidth
                          handleChange={(e) =>
                            onChange(e?.target?.value, "date")
                          }
                          mobileDateWithBatch
                          markDateList={holidayDates ?? []}
                          minDate={
                            isPetInInpatientToday()
                              ? getTomorrowDate()
                              : new Date()
                          }
                          disabled={isUnEditable}
                        />
                      </div>
                    </Grid>
                  )}
                  {petValues?.appointmentOption === "Later" &&
                    petValues?.date &&
                    petValues?.vetName?.value &&
                    !isUnEditable && (
                      <div className="w100Per">
                        <div className="flex-row-wrap1 mh10">
                          {getBookableSlotList()?.length > 0 &&
                            getBookableSlotList()?.map((item, i) => {
                              return (
                                <div
                                  key={i}
                                  onClick={() => {
                                    petValues?.serviceType?.value === "Surgery"
                                      ? handleSelectectedTimeIds(item)
                                      : handleSelectTime(item);
                                  }}
                                  className={
                                    (
                                      petValues?.serviceType?.value ===
                                      "Surgery"
                                        ? timeObject?.ids?.find(
                                            (id) =>
                                              id?.startTime === item?.startTime,
                                          )
                                        : selectTime === item?.startTime
                                    )
                                      ? "bgContainerSelected cursor"
                                      : "bgContainerUnselected cursor"
                                  }
                                >
                                  {item?.startTime}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}

                  {selectTimeIdError && (
                    <Typography color="error" className="ml20 mt5 fs14">
                      Time is Requried
                    </Typography>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CustomTextField
                      name="remarks"
                      fullWidth
                      handleChange={(e) =>
                        onChange(e?.target?.value, "remarks")
                      }
                      value={petValues?.remarks}
                      label="Remarks"
                      multiline
                    />
                  </Grid>
                  <div className="flex1-center mt20">
                    <div>
                      <CustomButton
                        text="Submit"
                        smallBtn
                        onClick={onPreview}
                      />
                    </div>
                  </div>
                </Grid>
              </div>
            </div>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid container className="flex-center">
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Card sx={cardSty} className="CustomCard-back-appointment">
                <div className="maint">
                  <div className="flex-row">
                    <Grid item xs={3}>
                      <div className="flex-center">
                        {selectedPet?.petImage ? (
                          <CardMedia
                            image={selectedPet?.petImage}
                            className="CustomCard-img3-bill"
                          />
                        ) : (
                          <div className="flex-center h50img">
                            <Typography className="font-bold fs30 white-color capitalize">
                              {selectedPet?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={9}>
                      <div className="flex-row">
                        <div className="flex-start">
                          <div className="flex-column">
                            <div className="flex-row">
                              <Typography
                                variant="body1"
                                className="mb10 font-bold fs14 capitalize"
                              >
                                {selectedPet?.petName}
                              </Typography>
                              <Typography
                                variant="body1"
                                className={`ml5 font-medium capitalize fs14 ${
                                  selectedPet?.gender === "male"
                                    ? "card-blue-color"
                                    : "card-rose-color"
                                }`}
                              >
                                {`(${selectedPet?.gender})`}
                              </Typography>
                            </div>
                            <Typography
                              variant="body2"
                              className="mb10 txt-regular card-gray-color fs12"
                            >
                              {selectedPet?.breed}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </div>
                  <div className="flex-row iconcontainer flex-space-btwn">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <Typography className="font-bold fs14 capitalize flex-center h35">
                        {selectedPet?.userName}
                      </Typography>
                    </div>

                    <div className="meeting-doctor">
                      {moment(new Date(selectedPet?.dob)).fromNow()} (
                      {selectedPet?.dob})
                    </div>
                  </div>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Grid> */}
        </Grid>
      </CustomModal>

      <CustomModal
        open={previewModVsble}
        onClose={onClosePreviewMod}
        modalWidth={35}
        modalWoHeader
      >
        <div className="flex-row-ali-cen blu-back ph15 h60">
          <div
            className="br5 flex-center cursor back-btn"
            onClick={onClosePreviewMod}
          >
            <ArrowBackIcon
              sx={{ width: 20, height: 20, color: AppColors.white }}
            />
          </div>

          <Typography className="white-color fs16 font-bold ml15">
            Review
          </Typography>
        </div>
        <div className="scroll-80vh-new">
          <div className="p15">
            <Typography className="fs14 txt-semi-bold blue-color">
              Appointment Details
            </Typography>
            <div className="mt10 gray-brder">
              <div className="gray-brder">
                <div className="flex-row">
                  <div className="w48Per">
                    <div className="flex-row-ali-cen">
                      {selectedPet?.petImage ? (
                        <CardMedia
                          image={selectedPet?.petImage}
                          className="CustomCard-img4-bill"
                        />
                      ) : (
                        <div className="flex-center h40img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {selectedPet?.petName?.[0]}
                          </Typography>
                        </div>
                      )}

                      <div className="flex-column ml10">
                        <div className="flex-row-ali-cen">
                          <Typography className="card-black txt-semi-bold fs12 capitalize">
                            {selectedPet?.petName}
                          </Typography>
                          <Typography
                            className={`ml5 font-medium capitalize fs12 ${
                              selectedPet?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${selectedPet?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="txt-regular card-black1 fs10">
                          {selectedPet?.breed}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex-row-between-align-center mt10">
                      <div className="flex-row-ali-cen">
                        <AccountCircleOutlinedIcon sx={eyeBtn} />
                        <Typography className="txt-semi-bold card-black fs12 capitalize flex-center ml5">
                          {selectedPet?.userName}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <PhoneInTalkIcon sx={eyeBtn} />
                        <Typography className="txt-regular card-black fs12 capitalize flex-center ml5">
                          {selectedPet?.userMobile ?? selectedPet?.mobile}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div className="w4Per flex-center">
                    <div className="gry-ver-split" />
                  </div>
                  <div className="w48Per">
                    <div className="flex-row-ali-cen mt10">
                      <DataUsageIcon sx={eyeBtn} />
                      <Typography className="txt-regular card-black fs12 capitalize flex-center ml5">
                        {moment(new Date(selectedPet?.dob)).fromNow(true)} (
                        {selectedPet?.dob})
                      </Typography>
                    </div>
                    <div className="flex-row-between-align-center mt10">
                      <div className="flex-row-ali-cen w60Per">
                        <ColorLensIcon sx={eyeBtn} />
                        <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                          {selectedPet?.color ?? ""}
                        </Typography>
                      </div>
                      <div className="w40Per flex-end">
                        <div className="flex-row-ali-cen">
                          <ScaleIcon sx={w15h15BlueIcon} />
                          <Typography className="font-medium card-black fs14 capitalize flex-center ml5">
                            {selectedPet?.weight?.length > 0
                              ? `${selectedPet?.weight} KG`
                              : ""}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {moment(
                      new Date(
                        petValues?.appointmentOption === "Immediate"
                          ? new Date()
                          : petValues?.date,
                      ),
                    ).format("DD MMM YYYY")}{" "}
                    |{" "}
                    {petValues?.appointmentOption === "Immediate"
                      ? moment(new Date()).format("HH:mm")
                      : petValues?.serviceType?.value === "Surgery"
                        ? `${timeObject?.ids?.[0]?.startTime} -
                          ${
                            timeObject?.ids?.[timeObject?.ids?.length - 1]
                              ?.startTime
                          }`
                        : selectTime}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Appointment Date & Time
                  </Typography>
                </div>
                <div>
                  <CalendarMonthIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.consultationMode === "Home"
                      ? "Home Visit"
                      : petValues?.consultationMode}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Consultation Mode
                  </Typography>
                </div>
                <div>
                  <AccessTimeIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="flex-row-between-align-center mt10">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.visitType?.value}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Visit Type
                  </Typography>
                </div>
                <div>
                  <CalendarMonthIcon sx={eyeBtn} />
                </div>
              </div>
              <div className="gry-hor-split4 mv10" />
              <div className="flex-row-between-align-center">
                <div>
                  <Typography className="txt-semi-bold fs14 black30">
                    {petValues?.consultationMode === "Physical" ||
                    petValues?.consultationMode === "Virtual"
                      ? clinicDet?.name
                      : (userDetails?.name ?? selectedPet?.userName)}
                  </Typography>
                  <Typography className="font-medium fs12 black2">
                    {petValues?.consultationMode === "Physical"
                      ? clinicDet?.address
                      : petValues?.consultationMode === "Virtual"
                        ? "Online"
                        : userDetails?.address}
                  </Typography>
                  <Typography className="txt-semi-bold fs12 gray40">
                    Location
                  </Typography>
                </div>
                <div>
                  <DomainIcon sx={eyeBtn} />
                </div>
              </div>
            </div>

            <Typography className="fs14 txt-semi-bold blue-color mt10">
              Service Details
            </Typography>
            {petValues?.serviceType?.value !== "Consultation" &&
              petValues?.serviceType?.value !== "Surgery" &&
              petValues?.serviceName?.map((ser) => (
                <div className="mt10 apnt-card">
                  <div className="flex-row">
                    <div className="w70Per">
                      <Custom3dotString
                        str={ser?.serviceName}
                        className="fs14 font-bold black30"
                        length={25}
                      />
                    </div>
                    <div className="w30Per">
                      <Typography className="fs14 font-bold red-color">
                        Rs. {ser?.servicePrice}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row">
                    <div className="w70Per">
                      <Custom3dotString
                        str={ser?.variantName}
                        className="fs12 font-medium gray40"
                        length={25}
                      />
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {ser?.estimatedDuration} Mins
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        {petValues?.serviceType?.value === "Grooming"
                          ? "Groomer"
                          : petValues?.serviceType?.value === "Lab Tests" ||
                              petValues?.serviceType?.value ===
                                "Radiology Tests"
                            ? "Technician"
                            : // : petValues?.serviceType?.value === "Others"
                              // ? "Other"
                              "Vet"}{" "}
                        Name
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {petValues?.vetName?.name ??
                          `${getRightSaluation(
                            clinicVets,
                            petValues?.vetName?.value,
                          )}${
                            clinicVets?.find(
                              (vt) =>
                                vt?.doctorId === petValues?.vetName?.value,
                            )?.name
                          }` ??
                          ""}
                      </Typography>
                    </div>
                  </div>
                  {petValues?.assignedUsers?.length > 0 && (
                    <div className="flex-row">
                      <div className="w70Per">
                        <Typography className="fs12 font-medium gray40">
                          Assigned Users
                        </Typography>
                      </div>
                      <div className="w30Per">
                        <Typography className="fs12 font-medium gray40">
                          {getVetList()
                            ?.filter((vet) =>
                              petValues?.assignedUsers?.some(
                                (asUr) => asUr?.id === vet?.value,
                              ),
                            )
                            ?.map((vet) => vet?.name)
                            ?.join(", ") || ""}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            {(petValues?.serviceType?.value === "Consultation" ||
              petValues?.serviceType?.value === "Surgery") && (
              <div className="mt10 apnt-card">
                <div className="flex-row">
                  <div className="w100Per">
                    <Custom3dotString
                      str={petValues?.serviceType?.value}
                      className="fs14 font-bold black30"
                      length={25}
                    />
                  </div>
                </div>
                {petValues?.serviceType?.value === "Consultation" &&
                  petValues?.reason?.length > 0 && (
                    <div className="flex-row">
                      <div className="w70Per">
                        <Typography className="fs12 font-medium gray40">
                          Reason
                        </Typography>
                      </div>
                      <div className="w30Per">
                        <Typography className="fs12 font-medium gray40">
                          {petValues?.reason?.join(", ")}
                        </Typography>
                      </div>
                    </div>
                  )}
                {/* {petValues?.serviceType?.value === "Surgery" && ( */}
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      {/* Facility */}
                      {petValues?.consultationMode === "Home"
                        ? "Kit Name"
                        : "Facility"}
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {petValues?.facility?.name}
                    </Typography>
                  </div>
                </div>
                {/* )} */}
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      Vet Name
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {petValues?.vetName?.name ||
                        getVetList()?.find(
                          (vet) => vet?.value === petValues?.vetName?.value,
                        )?.name ||
                        getOthersByType(petValues?.serviceType?.value)?.find(
                          (vet) => vet?.value === petValues?.vetName?.value,
                        )?.name ||
                        getAllClinicUserList()?.find(
                          (vet) => vet?.value === petValues?.vetName?.value,
                        )?.name ||
                        ""}
                    </Typography>
                  </div>
                </div>
                {petValues?.assignedUsers?.length > 0 && (
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        Assigned Users
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {getVetList()
                          ?.filter((vet) =>
                            petValues?.assignedUsers?.some(
                              (asUr) => asUr?.id === vet?.value,
                            ),
                          )
                          ?.map((vet) => vet?.name)
                          ?.join(", ") || ""}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            )}
            {petValues?.serviceType?.value === "Others" ? (
              <div>
                <div className="flex-row">
                  <div className="w70Per">
                    <Typography className="fs12 font-medium gray40">
                      Vet Name
                    </Typography>
                  </div>
                  <div className="w30Per">
                    <Typography className="fs12 font-medium gray40">
                      {petValues?.vetName?.name ??
                        `${getRightSaluation(
                          clinicVets,
                          petValues?.vetName?.value,
                        )}${
                          clinicVets?.find(
                            (vt) => vt?.doctorId === petValues?.vetName?.value,
                          )?.name
                        }` ??
                        ""}
                    </Typography>
                  </div>
                </div>
                {petValues?.assignedUsers?.length > 0 && (
                  <div className="flex-row">
                    <div className="w70Per">
                      <Typography className="fs12 font-medium gray40">
                        Assigned Users
                      </Typography>
                    </div>
                    <div className="w30Per">
                      <Typography className="fs12 font-medium gray40">
                        {getVetList()
                          ?.filter((vet) =>
                            petValues?.assignedUsers?.some(
                              (asUr) => asUr?.id === vet?.value,
                            ),
                          )
                          ?.map((vet) => vet?.name)
                          ?.join(", ") || ""}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            <div className="flex-center mt20">
              <div>
                <CustomButton text="Done" onClick={handleSubmit} smallBtn />
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default BookAnAppointment;
